"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _constants = require("../constants/constants");
var _cart = require("../apis/shopify/cart");
var _utils = require("../utils/utils");
var _bwaEventLogger = _interopRequireDefault(require("./bwa-event-logger"));
var _gaEvents = require("../constants/ga-events");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CartGaEventHandler = {
  attachEvents: function attachEvents() {
    var _this = this;
    window.addEventListener(_constants.EVENT_TYPE.CUSTOM.BWA_CHECKOUT_BUTTON_RENDER, function () {
      return _this.sendCartGaEvent({
        eventName: _gaEvents.BWA_CHECKOUT_BUTTON_RENDER
      });
    });
    window.addEventListener(_constants.EVENT_TYPE.CUSTOM.BWA_CHECKOUT_BUTTON_SUBMIT, function (event) {
      return _this.sendCartGaEvent({
        eventName: _gaEvents.BWA_CHECKOUT_BUTTON_SUBMIT,
        mode: event.detail.mode
      });
    });
    window.addEventListener(_constants.EVENT_TYPE.CUSTOM.CLICK_NATIVE_CHECKOUT_BUTTON, function () {
      return _this.sendCartGaEvent({
        eventName: _gaEvents.CLICK_NATIVE_CHECKOUT_BUTTON
      });
    });
    window.addEventListener(_constants.EVENT_TYPE.CUSTOM.OTHER_CHECKOUT_BUTTON_SUBMIT, function () {
      return _this.sendCartGaEvent({
        eventName: _gaEvents.OTHER_CHECKOUT_BUTTON_SUBMIT
      });
    });
    window.addEventListener(_constants.EVENT_TYPE.CUSTOM.BWA_CHECKOUT_INTERSTITIAL_LOADER_RENDER, function () {
      return _this.sendCartGaEvent({
        eventName: _gaEvents.BWA_CHECKOUT_INTERSTITIAL_LOADER_RENDER
      });
    });
    window.addEventListener(_constants.EVENT_TYPE.CUSTOM.BWA_CHECKOUT_CART_LOADED, function () {
      return _this.sendCartGaEvent({
        eventName: _gaEvents.BWA_CHECKOUT_CART_LOADED
      });
    });
  },
  sendCartGaEvent: function () {
    var _sendCartGaEvent = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var _ref,
        eventName,
        _ref$mode,
        mode,
        cart,
        payload,
        _args = arguments;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, eventName = _ref.eventName, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? null : _ref$mode;
            _context.next = 3;
            return (0, _cart.fetchCart)();
          case 3:
            cart = _context.sent;
            payload = _objectSpread(_objectSpread({
              ecp: _constants.ECP,
              currency: _constants.INR,
              value: cart.total_price,
              ecp_store_id: window.storeId,
              is_meta_browser: String((0, _utils.isMetaBrowser)()),
              is_bwa_repeat_customer: String((0, _utils.isBwARepeatCustomer)())
            }, (0, _utils.getExperimentContext)()), {}, {
              mode: mode === null || mode === void 0 ? void 0 : mode.toString(),
              items: cart.items.map(function (item) {
                return {
                  item_id: item.id.toString(),
                  price: item.final_price,
                  quantity: item.quantity
                };
              })
            });
            Shopify.analytics.publish(eventName, payload);
            _bwaEventLogger["default"].logEvent(eventName, payload);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function sendCartGaEvent() {
      return _sendCartGaEvent.apply(this, arguments);
    }
    return sendCartGaEvent;
  }()
};
var _default = exports["default"] = CartGaEventHandler;
//# sourceMappingURL=cart-ga-event-handler.js.map
